import { render, staticRenderFns } from "./MatterProgramEvaluationForm.vue?vue&type=template&id=1fb4b463&scoped=true"
import script from "./MatterProgramEvaluationForm.vue?vue&type=script&lang=js"
export * from "./MatterProgramEvaluationForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=1fb4b463&prod&scoped=true&lang=css&external"
import style1 from "./MatterProgramEvaluationForm.vue?vue&type=style&index=1&id=1fb4b463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4b463",
  null
  
)

export default component.exports